import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';
import { HttpParamsEncoder } from '../../tools';
import { DataSourceResponse, ReceptPatient } from '../../models';

@Injectable({ providedIn: 'root' })
export class ReceptPatientService extends ApiService {
    endPoint = '/api/receptPatients';
    create(model: ReceptPatient) {
        return this.http.post(`${this.clinicsBaseURL}${this.endPoint}`, model);
    }
    update(id: string, model: ReceptPatient) {
        return this.http.put(`${this.clinicsBaseURL}${this.endPoint}/${id}`, model);
    }
    setNextVisitDate(id: string, nextVisitDate: Date) {
        return this.http.put(`${this.clinicsBaseURL}${this.endPoint}/${id}/SetNextVisitDate`, { nextVisitDate });
    }
    get(id: string): Observable<ReceptPatient> {
        return this.http.get<ReceptPatient>(`${this.clinicsBaseURL}${this.endPoint}/${id}`);
    }
    createInvoice(id: string) {
        return this.http.post(`${this.clinicsBaseURL}${this.endPoint}/${id}/CreateInvoice`, {});
    }
    getList(queryParams: any): Observable<DataSourceResponse<ReceptPatient>> {
        const params = new HttpParamsEncoder().encode(queryParams);
        return this.http.get<any>(`${this.clinicsBaseURL}${this.endPoint}`, { params });
    }
    getByRegisterPatientId(registerPatientId: string) {
        return this.http.get<any>(`${this.clinicsBaseURL}${this.endPoint}/byRegisterPatientId/${registerPatientId}`);
    }
    getByProvidedMedServiceId(providedMedServiceId: string) {
        return this.http.get<any>(`${this.clinicsBaseURL}${this.endPoint}/byProvidedMedServiceId/${providedMedServiceId}`);
    }
    getDiagnoses(id: string) {
        return this.http.get<any>(`${this.clinicsBaseURL}/odata/CaseHistoryDiagnoses/by-receptPatientId/${id}`);
    }
    
}
